import { useStore } from '@/providers/app-store-provider';
import { selectCurrencySettled } from '@/domain/currency/selectors';

export function useCurrencySettled() {
  return useStore(selectCurrencySettled);
}
